module.exports = __webpack_public_path__ + "static/img/4.ef51954.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/4.png
// module id = IMoz
// module chunks = 0